import { StrictMode, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CssBaseline, ThemeProvider } from '@mui/material';
import App from './App.jsx';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { LoadingProvider } from './contexts/LoadingContext.jsx';
import { ThemeModeProvider, useThemeMode } from './contexts/ThemeModeContext.jsx';
import { ToastProvider } from './contexts/ToastContext.jsx';
import { buildTheme } from './theme/theme.js';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30000, retry: 1, refetchOnWindowFocus: false } }
});

function RootApp() {
  const { mode, primaryColor } = useThemeMode();
  const theme = useMemo(() => buildTheme(mode, primaryColor), [mode, primaryColor]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastProvider>
        <LoadingProvider>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <AuthProvider>
                <App />
              </AuthProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </LoadingProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeModeProvider>
      <RootApp />
    </ThemeModeProvider>
  </StrictMode>
);
